import { Plus } from "lucide-react";

export default function AvailableCard({ table }) {
  return (
    <div
      data-testid={`available-card-${table.code}`}
      className="flex flex-col items-center justify-center h-full gap-3 py-4"
    >
      <div
        data-testid={`code-badge-${table.code}`}
        className="px-2.5 py-0.5 rounded-full max-w-full"
        style={{ backgroundColor: "#D0D0D0" }}
      >
        <span className="text-[11px] font-bold truncate block leading-tight" style={{ color: "#424242" }}>
          {table.code}
        </span>
      </div>

      <div
        data-testid={`plus-icon-${table.code}`}
        className="flex items-center justify-center rounded-full"
        style={{ width: 40, height: 40, backgroundColor: "#BDBDBD" }}
      >
        <Plus size={20} color="#FFFFFF" strokeWidth={2.5} />
      </div>
    </div>
  );
}
